import { OcrResult } from "@finway-group/shared/lib/models"
import React from "react"
import { useTranslation } from "react-i18next"
import { SectionHeader } from "./shared"

interface NoteProps {
    data: OcrResult
}

export const EInvoiceNote = ({ data }: NoteProps) => {
    const { t } = useTranslation()
    if (!data.eInvoiceData?.note) {
        return null
    }

    return (
        <div className="flex flex-col gap-10 mt-20">
            <SectionHeader title={t("label:note")} />
            <div className="border-1 border-gray-200 font-medium text-xs rounded-sm p-14">
                <span className="text-black font-medium">{data.eInvoiceData.note}</span>
            </div>
        </div>
    )
}
